import AtividadeOsService from "@/services/AtividadeOsService";
import { router } from "@/router";
import store from "@/store";
import helper from "@/helper";
import moment from 'moment'

export const actions = {
  cadastrarAtividadeOs: ({ commit, dispatch }) => {
    commit("setAtividadeOs", {
      id: "",
      ordem_servico_id: "",
      data_inicio: moment().format("YYYY-MM-DD"),
      data_termino: "",
      tecnico_id: "",
      descricao: "",
      concluida: false,
      horario_inicio: moment().format('HH:mm'),
      horario_termino: "",
    });

    dispatch("setModalCadastroAtividadeOs", true);
  },
  listarAtividadeOs: ({ commit }, data) => {
    commit("setOverlay", true);
    AtividadeOsService.listar(data)
      .then((res) => {
        commit('setAtividadesOs', res.data)
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  visualizarAtividadeOs: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    AtividadeOsService.editar(id)
      .then((res) => {
        commit("setAtividadeOs", { ...res.data });
        commit("setOverlay", false);
        dispatch("setModalCadastroAtividadeOs", true);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  salvarAtividadeOs: ({ commit, dispatch }, data) => {
    // dispatch("setModalCadastroAtividadeOs", false);
    commit("setOverlay", true);
    AtividadeOsService.salvar(data)
      .then((res) => {
        dispatch("listarAtividadeOs", {id: store.getters.getOrdemServico.id});
        commit("setOverlay", false);
        commit("snackbarSuccess", "OS cadastrada.");
        commit("setAtividadeOs", { ...store.getters.getAtividadeOs, id: res.data.id });
      })
      .catch((e) => {
        console.log(e);
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar OS.");
      });
  },
  atualizarAtividadeOs: ({ commit, dispatch }, data) => {
    // dispatch("setModalCadastroAtividadeOs", false);
    commit("setOverlay", true);
    AtividadeOsService.atualizar(data)
      .then((res) => {
        dispatch("listarAtividadeOs", {id: store.getters.getOrdemServico.id});
        commit("setOverlay", false);
        commit("snackbarInfo", "OS atualizada.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        commit("setOverlay", false);
        console.log(e);
        commit("snackbarError", "Erro ao atualizar OS.");
      });
  },
  excluirAtividadeOs: ({ commit, dispatch }, id) => {
    dispatch("setModalCadastroAtividadeOs", false);
    dispatch("setModalExcluirAtividadeOs", false);
    commit("setOverlay", false);
    AtividadeOsService.excluir(id)
      .then((res) => {
        commit("removeAtividadeOs", { id: id });
        commit("setOverlay", false);
        commit("snackbarError", "OS excluída.");
      })
      .catch((e) => {
        console.log(e);
        commit("snackbarError", "Erro ao excluir OS.");
      });
  },
  setModalCadastroAtividadeOs: ({ commit }, status) => {
    commit("setModalCadastroAtividadeOs", false);
    setTimeout(() => {
      commit("setModalCadastroAtividadeOs", status);
    }, 100);
  },
  setModalExcluirAtividadeOs: ({ commit }, status) => {
    commit("setModalExcluirAtividadeOs", false);
    setTimeout(() => {
      commit("setModalExcluirAtividadeOs", status);
    }, 100);
  },
  imprimirAtividadeOs: ({ commit }, id) => {
    commit("setOverlay", true);
    AtividadeOsService.imprimir(id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  setModalHistoricoStatusOS: ({ commit }, status) => {
    commit("setModalHistoricoStatusOS", false);

    setTimeout(() => {
      commit("setModalHistoricoStatusOS", status);
    }, 100);
  },
};

export default {};
